import React from 'react'

import { TextField } from '@masfront/common-b2c'
import { FastField, Field } from 'formik'

import { Typography, Box, MenuItem, Grid } from '@material-ui/core'

export default function AgentInfo({ brandOptions, productOptions, segmentOptions }: any) {
  return (
    <>
      <Box my={6}>
        <Typography variant="subtitle2" color="textSecondary">
          DATOS DE LA VENTA
        </Typography>
      </Box>
      <Grid container component={Box} spacing={5}>
        <Grid xs={4} item>
          <FastField
            fullWidth
            component={TextField}
            name="brand"
            variant="outlined"
            label="Marca"
            select
          >
            {brandOptions.map((elem: any) => {
              return (
                <MenuItem key={elem.key} value={elem.value}>
                  {elem.label}
                </MenuItem>
              )
            })}
          </FastField>
        </Grid>
        <Grid xs={4} item>
          <Field
            fullWidth
            component={TextField}
            name="product"
            variant="outlined"
            label="Producto"
            select
          >
            {productOptions.map((elem: any) => {
              return (
                <MenuItem key={elem.key} value={elem.value}>
                  {elem.label}
                </MenuItem>
              )
            })}
          </Field>
        </Grid>
        <Grid xs={4} item>
          <FastField
            fullWidth
            component={TextField}
            name="segment"
            variant="outlined"
            label="Segmento"
            select
          >
            {segmentOptions.map((elem: any) => {
              return (
                <MenuItem key={elem.key} value={elem.value}>
                  {elem.label}
                </MenuItem>
              )
            })}
          </FastField>
        </Grid>
      </Grid>
    </>
  )
}
